<template>
  <Button
    type="button"
    text
    severity="secondary"
    icon="pi pi-angle-down"
    iconPos="right"
    :label="buttonLabel"
    :aria-label="ariaLabel || buttonLabel"
    aria-haspopup="true"
    aria-controls="overlay_menu"
    v-bind="$attrs"
    @click="toggleUserMenu"
  />

  <Menu ref="userMenu" id="user-menu" :model="userMenuItems" :popup="true" class="w-auto">
    <template #item="{ label, item, props }">
      <!-- Normal routed items -->
      <router-link
        v-if="item.route !== pdfPath"
        v-slot="{ href, navigate }"
        :to="item.route"
        custom
      >
        <a :href="href" v-bind="props.action" @click="navigate">
          <span v-bind="props.icon" />
          <span v-bind="props.label">{{ label }}</span>
        </a>
      </router-link>

      <!-- PDF link opens in new tab with absolute URL -->
      <a
        v-else
        :href="getAbsolutePdfUrl()"
        target="_blank"
        rel="noopener noreferrer"
        v-bind="props.action"
      >
        <span v-bind="props.icon" />
        <span v-bind="props.label">{{ label }}</span>
      </a>
    </template>
  </Menu>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { RouterLink } from "vue-router";
import type { MenuItem } from "@/models";

interface Props {
  label?: string;
  ariaLabel?: string;
}

const props = withDefaults(defineProps<Props>(), {
  label: "Help",
  ariaLabel: "",
});

const buttonLabel = props.label;

// Refs
const userMenu = ref();

// PDF route identifier (used to distinguish special PDF item)
const pdfPath = "ResumeBuilderUserManual.pdf";

// Menu model
const userMenuItems = ref<MenuItem[]>([
  {
    label: "FAQ",
    icon: "pi pi-fw pi-question-circle",
    route: "/FAQ",
  },
  {
    label: "Contact Us",
    icon: "pi pi-fw pi-send",
    route: "/contact",
    class: "",
  },
  {
    label: "User Guide - PDF",
    icon: "pi pi-fw pi-file-pdf",
    route: pdfPath,
    class: "",
  },
]);

// Methods
const toggleUserMenu = (event: Event) => {
  (userMenu.value as any)?.toggle(event);
};

const getAbsolutePdfUrl = (): string =>
  `${window.location.origin}/ResumeBuilderUserManual_v1.5.pdf`;
</script>

<style scoped>
/* Keep styling minimal and let PrimeVue / global styles handle most visuals */
</style>
